import { logIn } from "./login"
import { code } from "./code"

export const login = {
  logIn,
  code,
}
